import React, { FC, ReactNode, useEffect, useState } from 'react';
import Header from '../HeaderDynamicPages/Header';
import Layout from '../Layout/Layout';
import {
    ButtonWithCountry,
    CloseButtton,
    CloseIcon,
    Container,
    CountryBox,
    CountryList,
    CountryListOption,
    CountryListOptionLabel,
    Description,
    FormTitle,
    PersonBox,
    PersonBoxTitle,
    PersonContainer,
    SearchButton,
    SearchFormsContainer,
    SearchFrom,
    SearchTextField,
    StateCointainer,
    Subtitle,
    Title,
} from './ContactStyle';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import ContactData from './ContactData/ContactData';
import {
    ContactPartnerDetailsItemInterface,
    ContactPartnerItemsInterface,
    FieldContactsInterface,
    FieldHaendlerInterface,
    FieldMerchantsInterface,
} from '../../interfaces/internationalContact';
import { useFetchPartnerDetails } from '../../hooks/useFetchPartnerDetails';
import { ContactPartnerDetailsExmaple } from '../../templateObjects/internationalContact';
import ContactPerson from './ContactPerson/ContactPerson';
import { useFetchCountryStates } from '../../hooks/useFetchCountryStates';
import { useFetchStatePartners } from '../../hooks/useFetchStatePartners';
import { EN_AU, ES_US, IT, EN_US, ZH_HANS } from '../../constants/languageCode';
import contactTranslations from '../../JSON/StaticSitesTranslations/contactTranslations.json';
import { getSiteName } from '../../utils/getSiteName';

interface ContactProps {
    contactPartner: ContactPartnerItemsInterface;
}

const Contact: FC<ContactProps> = ({ contactPartner: { items: contactPartnerItems } }) => {
    const { language } = useI18next();
    const { t } = useTranslation();
    const [countriesList, setCountriesList] = useState(contactPartnerItems);
    const [distributorsList, setDistributorsList] = useState([]);
    const [country, setCountry] = useState(countriesList?.length > 0 ? countriesList[0]['Country Name GB'] : '');
    const [countryShort, setCountryShort] = useState(
        countriesList?.length > 0 ? countriesList[0]['Country Short'] : ''
    );
    const [vkg, setVkg] = useState(countriesList?.length > 0 ? countriesList[0][' VKG'] : '');
    const [partnerState, setPartnerState] = useState('');
    const [contactPersonData, setContactPersonData] =
        useState<ContactPartnerDetailsItemInterface>(ContactPartnerDetailsExmaple);
    const [currentCountrySearch, setCurrentCountrySearch] = useState('');
    const [currentDistributorSearch, setCurrentDistributorSearch] = useState('');
    const [isActiveCountriesList, setIsActiveCountriesList] = useState(false);
    const [isActiveDistributorsList, setIsActiveDistributorsList] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [distributor, setDistributor] = useState();
    const [currentDistributor, setCurrentDistributor] = useState('');
    const [currentCountry, setCurrentCountry] = useState('');
    let isBothEmptyDistributors = true;
    let isBothEmptyCountries = true;
    const languages = [IT, EN_AU, EN_US, ES_US];
    const itemKey = 0;
    const itemValue = 1;
    const MIN_LENGTH_OF_ITEMS = 10;

    const changeLanguageCode = (language: string): string => {
        switch (language) {
            case IT:
                return IT;
            case EN_AU:
                return 'au';
            case EN_US:
                return 'us';
            case ES_US:
                return 'us';
            default:
                return '';
        }
    };

    const getPartnerDetails = async (): Promise<void> => {
        const data = await useFetchPartnerDetails(countryShort, vkg);
        setContactPersonData(data);
    };

    const getCountryStates = async (): Promise<void> => {
        const lang = changeLanguageCode(language);
        const data = await useFetchCountryStates(lang);
        if (language === EN_US || language === ES_US) {
            Object?.entries(data)?.length > 1 &&
                setDistributorsList(
                    Object?.entries(data)
                        ?.map(
                            (item: any) =>
                                Array.isArray(item) &&
                                item?.length > 0 &&
                                item?.map((item: any) => (typeof item === 'object' ? Object?.entries(item) : item))
                        )
                        ?.map((item: any) => item.flat())
                );
        } else {
            setDistributorsList(Object?.entries(data));
        }
    };

    const getStatePartnerDetails = async (): Promise<void> => {
        if (language === EN_AU) {
            const data = await useFetchStatePartners(partnerState, partnerState);
            setContactPersonData(data);
        } else {
            const lang = changeLanguageCode(language);
            const data = await useFetchStatePartners(lang, partnerState);
            setContactPersonData(data);
        }
    };

    useEffect(() => {
        languages.indexOf(language) > -1 && getCountryStates();
    }, []);

    useEffect(() => {
        if ((distributorsList?.length > 0 && language === EN_US) || language === ES_US) {
            distributorsList[0]?.length > 0 && setDistributor(distributorsList[0][1][itemValue] ?? '');
            distributorsList[0]?.length > 0 && setPartnerState(distributorsList[0][1][itemKey] ?? '');
        } else if (distributorsList?.length > 0) {
            distributorsList[0]?.length > 0 && setDistributor(distributorsList[0][itemValue] ?? '');
            distributorsList[0]?.length > 0 && setPartnerState(distributorsList[0][itemKey] ?? '');
        }
    }, [distributorsList]);

    const displayCountryList = (): ReactNode => (
        <>
            <ButtonWithCountry
                onClick={() => setIsActiveCountriesList((isActiveCountriesList) => !isActiveCountriesList)}
            >
                {country}
            </ButtonWithCountry>
            <CountryBox isActive={isActiveCountriesList}>
                <SearchTextField
                    type="text"
                    value={currentCountrySearch}
                    onChange={(e) => setCurrentCountrySearch(e.target.value)}
                />
                <CountryList>
                    {countriesList?.length > 0 &&
                        countriesList
                            ?.filter((item) => {
                                if (currentCountrySearch === '') {
                                    return item;
                                } else if (
                                    item['Country Name GB']
                                        .toLocaleLowerCase()
                                        .includes(currentCountrySearch.toLowerCase())
                                ) {
                                    return item;
                                }
                            })
                            ?.map((item: any) => (
                                <CountryListOption
                                    onClick={() => {
                                        setCountry(item['Country Name GB']);
                                        setCountryShort(item['Country Short']);
                                        setVkg(item[' VKG']);
                                        setIsActiveCountriesList((isActiveCountriesList) => !isActiveCountriesList);
                                    }}
                                    key={item['Country Name GB']}
                                >
                                    {item['Country Name GB']}
                                </CountryListOption>
                            ))}
                    {isBothEmptyCountries && (
                        <CountryListOption>{`${t('noResultsMatch')} "${currentCountrySearch}"`}</CountryListOption>
                    )}
                </CountryList>
            </CountryBox>
        </>
    );

    const displayDistributorList = (): ReactNode => (
        <>
            <ButtonWithCountry
                onClick={() => setIsActiveDistributorsList((isActiveDistributorsList) => !isActiveDistributorsList)}
            >
                {distributor}
            </ButtonWithCountry>
            <CountryBox isActive={isActiveDistributorsList}>
                {distributorsList?.length > MIN_LENGTH_OF_ITEMS ||
                    ((language === ES_US || language === EN_US) && (
                        <SearchTextField
                            type="text"
                            value={currentDistributorSearch}
                            onChange={(e) => setCurrentDistributorSearch(e.target.value)}
                        />
                    ))}
                <CountryList>
                    {distributorsList?.length > 0 && language !== EN_US && language !== ES_US
                        ? distributorsList
                              ?.filter((item) => {
                                  if (currentDistributorSearch === '') {
                                      return item;
                                  } else if (
                                      item[itemValue]
                                          .toLocaleLowerCase()
                                          .includes(currentDistributorSearch.toLowerCase())
                                  ) {
                                      return item;
                                  }
                              })
                              ?.map((item: any) => (
                                  <CountryListOption
                                      isWithoutSearch={distributorsList?.length < MIN_LENGTH_OF_ITEMS}
                                      onClick={() => {
                                          setDistributor(item[itemValue]);
                                          setPartnerState(item[itemKey]);
                                          setIsActiveDistributorsList(
                                              (isActiveDistributorsList) => !isActiveDistributorsList
                                          );
                                      }}
                                      key={item[itemKey]}
                                  >
                                      {item[itemValue]}
                                  </CountryListOption>
                              ))
                        : distributorsList
                              ?.map((item: any) =>
                                  item.filter((item: any) => {
                                      if (currentDistributorSearch === '') {
                                          return item;
                                      } else if (
                                          item[itemValue]
                                              .toLocaleLowerCase()
                                              .includes(currentDistributorSearch.toLowerCase())
                                      ) {
                                          return item;
                                      }
                                  })
                              )
                              ?.map((item: any, index: number) => {
                                  if (item?.length > 0) {
                                      isBothEmptyDistributors = false;
                                      return (
                                          <>
                                              <CountryListOptionLabel>
                                                  {index === 0 ? 'USA' : 'Canada'}
                                              </CountryListOptionLabel>
                                              {item?.map((item: any) => {
                                                  if (item[itemValue]?.length > 1) {
                                                      return (
                                                          <CountryListOption
                                                              onClick={() => {
                                                                  setDistributor(item[itemValue]);
                                                                  setPartnerState(item[itemKey]);
                                                                  setIsActiveDistributorsList(
                                                                      (isActiveDistributorsList) =>
                                                                          !isActiveDistributorsList
                                                                  );
                                                              }}
                                                              key={item[itemKey]}
                                                          >
                                                              {item[itemValue]}
                                                          </CountryListOption>
                                                      );
                                                  }
                                              })}
                                          </>
                                      );
                                  }
                              })}
                    {(isBothEmptyDistributors && language === EN_US) ||
                        (language === ES_US && (
                            <CountryListOption>{`${t(
                                'noResultsMatch'
                            )} "${currentDistributorSearch}"`}</CountryListOption>
                        ))}
                </CountryList>
            </CountryBox>
        </>
    );

    const displayPerson = (): ReactNode => (
        <PersonContainer isVisible={isVisible}>
            <PersonBox>
                <CloseButtton onClick={() => setIsVisible((isVisible) => !isVisible)}>
                    <CloseIcon />
                </CloseButtton>
                {!contactPersonData.hasOwnProperty('merchants') && !contactPersonData.hasOwnProperty('contacts') && (
                    <>
                        <PersonBoxTitle>
                            {t('contactTermPerCountry')} {currentCountry}
                        </PersonBoxTitle>
                        <ContactPerson contactPersonData={contactPersonData} />
                    </>
                )}
                {contactPersonData?.haendler?.length > 0 && (
                    <>
                        <PersonBoxTitle>
                            {t('distributorTermPerCountry')} {currentCountry}
                        </PersonBoxTitle>
                        {contactPersonData.haendler.map((item: FieldHaendlerInterface, index: number) => (
                            <ContactPerson key={item?.Name ?? index} contactPersonData={item} />
                        ))}
                    </>
                )}
                {contactPersonData?.merchants?.length > 0 && (
                    <>
                        <PersonBoxTitle>
                            {t('distributorTermPerCountry')} {currentDistributor}
                        </PersonBoxTitle>
                        {contactPersonData.merchants.map((item: FieldMerchantsInterface, index: number) => (
                            <ContactPerson
                                key={item?.name ?? index}
                                contactPersonData={item}
                                currentDistributorCode={partnerState}
                            />
                        ))}
                    </>
                )}
                {contactPersonData?.contacts?.length > 0 && (
                    <>
                        <PersonBoxTitle>
                            {t('distributorTermPerCountry')} {currentDistributor}
                        </PersonBoxTitle>
                        {contactPersonData.contacts.map((item: FieldContactsInterface, index: number) => {
                            const currentSectionTitle = item?.sectionTitle ?? '';
                            return (
                                <StateCointainer key={currentSectionTitle ?? index}>
                                    <PersonBoxTitle>{currentSectionTitle}</PersonBoxTitle>
                                    {item?.merchants?.length > 0 &&
                                        item.merchants.map((item: FieldMerchantsInterface, index: number) => (
                                            <ContactPerson key={item?.name ?? index} contactPersonData={item} />
                                        ))}
                                </StateCointainer>
                            );
                        })}
                    </>
                )}
            </PersonBox>
        </PersonContainer>
    );

    const handleSubmitCountryForm = (e: any): void => {
        e.preventDefault();
        getPartnerDetails();
        setCurrentCountrySearch('');
        setCurrentCountry(country);
        setIsActiveCountriesList(false);
        setIsVisible(true);
    };

    const handleSubmitDistributorForm = (e: any): void => {
        e.preventDefault();
        getStatePartnerDetails();
        setCurrentDistributorSearch('');
        setCurrentDistributor(distributor);
        setIsActiveDistributorsList(false);
        setIsVisible(true);
    };

    return (
        <Layout title={`${getSiteName(language)} | ${t('contact')}`} languageVersionsUrl={contactTranslations}>
            <Header item={t('contact')} />
            <Container>
                <Title>{t('contact')}</Title>
                <Subtitle>{t('contactPartner')}</Subtitle>
                <Description>{t('contactDescription')}</Description>
                <SearchFormsContainer>
                    <SearchFrom onSubmit={handleSubmitCountryForm}>
                        <FormTitle>
                            {language === ZH_HANS ? 'BOGE 方向指引 - 国际 ' : 'BOGE Direct - International'}
                        </FormTitle>
                        {displayCountryList()}
                        <SearchButton>{t('search')}</SearchButton>
                    </SearchFrom>
                    {languages.indexOf(language) !== -1 && (
                        <SearchFrom onSubmit={handleSubmitDistributorForm}>
                            <FormTitle>{t('distributorsRegion')}</FormTitle>
                            {displayDistributorList()}
                            <SearchButton>{t('search')}</SearchButton>
                        </SearchFrom>
                    )}
                </SearchFormsContainer>
            </Container>
            {displayPerson()}
            <ContactData />
        </Layout>
    );
};

export default Contact;
